import { debugLog } from "../Utils/LogUtils";
import { useEffect } from 'react';
import { useAuthenticationStatus } from "../Authentication/AuthenticationStatusProvider";
import { provinceShortName } from "../Utils/PlanUtils";

export default function useAssignDefaultAgentValues(enrolmentState) {
    const { authenticationStatus } = useAuthenticationStatus();

    //Assign the default agent values to the agent state, if the user is authenticated
    //and the enrolment data does not already contain an agent code
    useEffect(() => {
        //if (!enrolmentState.enrollment.state) { return; }
        if (!authenticationStatus.user || enrolmentState.agent.code !== '') { return; } // TODO check if correct
        enrolmentState.setAgent({
            ...enrolmentState.agent,
            code: authenticationStatus.user.agentCodes[0].code,
            province: provinceShortName(authenticationStatus.user.agentCodes[0].province), // TODO should this ever not be short name? -Julian
            firstName: authenticationStatus.user.agentCodes[0].firstName,
            lastName: authenticationStatus.user.agentCodes[0].lastName,
            email: authenticationStatus.user.agentCodes[0].email,
        });

        enrolmentState.setCommon({
            ...enrolmentState.common,
            agentCode: authenticationStatus.user.agentCodes[0].code,
            agentName: authenticationStatus.user.agentCodes[0].firstName + (authenticationStatus.user.agentCodes[0].lastName ? ' ' + authenticationStatus.user.agentCodes[0].lastName : ''), // TODO determine name format -Julian
            signingProvince: provinceShortName(authenticationStatus.user.agentCodes[0].code.province),
        });

        debugLog("useAssignDefaultAgentValues.js");
    }, [authenticationStatus]);
}